// DS: i7.18
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const EditorHRule: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path d="M20 6a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 002 0V7h12v1a1 1 0 102 0V6zM17 12a1 1 0 01-1 1H8a1 1 0 110-2h8a1 1 0 011 1zM20 18a1 1 0 01-1 1H5a1 1 0 01-1-1v-2a1 1 0 112 0v1h12v-1a1 1 0 112 0v2z"></path>
      </svg>
    </IconWrap>
  );
};
EditorHRule.displayName = 'EditorUnderline';

export default EditorHRule;
